import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-small text-muted mb-4" }, "Details", -1)
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-client_id"
}, " Client ", -1)
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-site_id"
}, "Site", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-user_id"
}, "Technician", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-serial_number"
}, "Serial Number", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-equipment_id"
}, "Equipment", -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-client-tag_number"
}, "Tag Number", -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-client-tag_number"
}, "SAP / Work Order", -1)
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-name"
}, "Type of Job", -1)
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-progress"
}, "Work Progress", -1)
const _hoisted_31 = { class: "col-lg-6" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-diagnosed"
}, "System Diagnosed/Request", -1)
const _hoisted_34 = { class: "col-lg-6" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-remarks"
}, "Action Taken", -1)
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-start"
}, "Start date and time", -1)
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-end"
}, "End date and time", -1)
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "create-maintenance-next_service_reminder"
}, "Next Service Date Reminder", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (_ctx.modelValue)
                  ? (_openBlock(), _createBlock(_component_n_select, {
                      key: 0,
                      id: "create-maintenance-client_id",
                      value: _ctx.modelValue.client_id,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.client_id) = $event)),
                      disabled: "",
                      options: _ctx.clientOptions,
                      loading: !_ctx.clientOptions,
                      size: "large"
                    }, null, 8, ["value", "options", "loading"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_n_select, {
                  id: "create-maintenance-site_id",
                  value: _ctx.modelValue.site_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.site_id) = $event)),
                  disabled: "",
                  options: _ctx.siteOptions,
                  loading: !_ctx.siteOptions,
                  size: "large"
                }, null, 8, ["value", "options", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_n_select, {
                  id: "create-maintenance-user_id",
                  value: _ctx.modelValue.user_id,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.user_id) = $event)),
                  disabled: "",
                  options: _ctx.userOptions,
                  loading: !_ctx.userOptions,
                  size: "large"
                }, null, 8, ["value", "options", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_n_input, {
                  id: "create-maintenance-serial_number",
                  value: _ctx.modelValue.serial_number,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.serial_number) = $event)),
                  disabled: "",
                  type: "text",
                  size: "large",
                  placeholder: "Serial Number"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_n_select, {
                  id: "create-maintenance-equipment_id",
                  value: _ctx.modelValue.equipment_id,
                  "onUpdate:value": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.equipment_id) = $event)),
                    _ctx.onEquipmentChanged
                  ],
                  disabled: _ctx.viewOnly,
                  options: _ctx.equipmentOptions,
                  loading: _ctx.equipmentLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onEquipmentSearch
                }, null, 8, ["value", "disabled", "options", "loading", "onSearch", "onUpdate:value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_n_input, {
                  id: "create-client-tag_number",
                  value: _ctx.modelValue.tag_number,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValue.tag_number) = $event)),
                  disabled: _ctx.viewOnly,
                  type: "text",
                  size: "large",
                  placeholder: "Tag Number"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_n_input, {
                  id: "create-client-tag_number",
                  value: _ctx.modelValue.additional.work_order_number,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelValue.additional.work_order_number) = $event)),
                  disabled: _ctx.viewOnly,
                  type: "text",
                  size: "large",
                  placeholder: "SAP / Work Order"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_n_select, {
                  id: "create-maintenance-name",
                  value: _ctx.modelValue.name,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelValue.name) = $event)),
                  disabled: _ctx.viewOnly,
                  options: _ctx.jobOptions,
                  loading: _ctx.jobLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onJobSearch
                }, null, 8, ["value", "disabled", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_n_select, {
                  id: "create-maintenance-progress",
                  value: _ctx.modelValue.progress,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelValue.progress) = $event)),
                  disabled: _ctx.viewOnly,
                  options: _ctx.workProgressOptions,
                  loading: _ctx.workProgressLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onWorkProgressSearch
                }, null, 8, ["value", "disabled", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_n_input, {
                  type: "textarea",
                  id: "create-client-diagnosed",
                  value: _ctx.modelValue.diagnosed,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelValue.diagnosed) = $event)),
                  disabled: _ctx.viewOnly,
                  size: "large",
                  placeholder: "System Diagnosed/Request"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_n_input, {
                  type: "textarea",
                  id: "create-client-remarks",
                  value: _ctx.modelValue.remarks,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelValue.remarks) = $event)),
                  disabled: _ctx.viewOnly,
                  size: "large",
                  placeholder: "Action Taken"
                }, null, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_n_date_picker, {
                  id: "create-maintenance-start",
                  "formatted-value": _ctx.startDatetime,
                  "onUpdate:formattedValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDatetime) = $event)),
                  disabled: _ctx.viewOnly,
                  type: "datetime",
                  format: "yyyy-MM-dd HH:mm",
                  size: "large",
                  clearable: "",
                  "is-date-disabled": _ctx.startDateDisabled,
                  "is-time-disabled": _ctx.startTimeDisabled,
                  "on-update:show": _ctx.onStartChanged
                }, null, 8, ["formatted-value", "disabled", "is-date-disabled", "is-time-disabled", "on-update:show"])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_n_date_picker, {
                  id: "create-maintenance-end",
                  "formatted-value": _ctx.endDatetime,
                  "onUpdate:formattedValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endDatetime) = $event)),
                  type: "datetime",
                  format: "yyyy-MM-dd HH:mm",
                  size: "large",
                  clearable: "",
                  disabled: !_ctx.startDatetime || _ctx.viewOnly,
                  "is-date-disabled": _ctx.endDateDisabled,
                  "is-time-disabled": _ctx.endTimeDisabled,
                  "on-update:show": _ctx.onEndChanged
                }, null, 8, ["formatted-value", "disabled", "is-date-disabled", "is-time-disabled", "on-update:show"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createVNode(_component_n_date_picker, {
                  id: "create-maintenance-next_service_reminder",
                  "formatted-value": _ctx.modelValue.next_service_reminder,
                  "onUpdate:formattedValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelValue.next_service_reminder) = $event)),
                  type: "date",
                  format: "yyyy-MM-dd",
                  size: "large",
                  clearable: "",
                  disabled: !_ctx.endDatetime || _ctx.viewOnly,
                  "is-date-disabled": _ctx.nextServiceDateDisabled
                }, null, 8, ["formatted-value", "disabled", "is-date-disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}